// Product Card Add to Cart Functionality
(function() {
  'use strict';

  // Wait for DOM to be ready
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Initialize product card functionality
  function initProductCards() {
    console.log('Initializing product cards...');
    // Handle variant selection and price updates
    const variantSelectors = document.querySelectorAll('.product-variant-overlay');
    
    variantSelectors.forEach(selector => {
      const productId = selector.dataset.productId;
      const radioButtons = selector.querySelectorAll('input[type="radio"]');
      const priceContainer = document.getElementById(`product-price-${productId}`);
      const priceAmount = document.getElementById(`product-price-amount-${productId}`);
      const priceCompare = document.getElementById(`product-price-compare-${productId}`);
      
      radioButtons.forEach(radio => {
        radio.addEventListener('change', function() {
          if (this.checked) {
            const variantPrice = parseInt(this.dataset.variantPrice);
            const variantComparePrice = parseInt(this.dataset.variantComparePrice);
            const variantAvailable = this.dataset.variantAvailable === 'true';
            
            // Update price amount
            if (priceAmount) {
              const formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: window.Shopify?.currency?.active || 'USD'
              }).format(variantPrice / 100);
              priceAmount.textContent = formattedPrice;
            }
            
            // Update compare price
            if (priceCompare) {
              if (variantComparePrice && variantComparePrice > variantPrice) {
                const formattedComparePrice = new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: window.Shopify?.currency?.active || 'USD'
                }).format(variantComparePrice / 100);
                priceCompare.textContent = formattedComparePrice;
                priceCompare.style.display = 'inline';
                priceContainer.classList.add('product-price--compare');
                priceAmount.classList.add('product-price__amount--on-sale');
              } else {
                priceCompare.style.display = 'none';
                priceContainer.classList.remove('product-price--compare');
                priceAmount.classList.remove('product-price__amount--on-sale');
              }
            }
            
            // Update availability styling
            const variantOptions = selector.querySelectorAll('.variant-option');
            variantOptions.forEach(option => {
              option.classList.remove('selected');
            });
            this.closest('.variant-option').classList.add('selected');
            
            // Update add to cart button
            const addToCartBtn = document.querySelector(`[data-product-id="${productId}"] .product-add-to-cart-btn`);
            if (addToCartBtn) {
              addToCartBtn.dataset.variantId = this.dataset.variantId;
              addToCartBtn.dataset.productPrice = (variantPrice / 100).toFixed(2);
              
              if (variantAvailable) {
                addToCartBtn.disabled = false;
                const btnText = addToCartBtn.querySelector('.btn-text');
                if (btnText) {
                  // Check if this is a single variant product by looking for price above button
                  const priceAboveBtn = document.querySelector(`#product-card-price-${productId}`);
                  if (priceAboveBtn) {
                    console.log(variantPrice, 'variant price');
                    // Single variant product - update price above button
                    updatePriceAboveButton(productId, variantPrice, parseFloat(this.dataset.variantComparePrice));
                    btnText.textContent = 'Adaugă in coş';
                  } else {
                    // Multi-variant product - update regular price display
                    btnText.textContent = 'Adaugă in coş';
                  }
                }
              } else {
                addToCartBtn.disabled = true;
                const btnText = addToCartBtn.querySelector('.btn-text');
                if (btnText) {
                  btnText.textContent = 'Epuizat';
                }
              }
            }
          }
        });
      });
      
      // Initialize first variant as selected
      const firstRadio = radioButtons[0];
      if (firstRadio) {
        firstRadio.checked = true;
        firstRadio.dispatchEvent(new Event('change'));
      }
    });

    // Handle single variant products (no variant selector)
    const singleVariantButtons = document.querySelectorAll('.product-add-to-cart-btn');
    singleVariantButtons.forEach(button => {
      const productId = button.dataset.productId;
      const variantId = button.dataset.variantId;
      const productPrice = button.dataset.productPrice;
      
      // Check if this is a single variant product by looking for price above button
      const priceAboveBtn = document.querySelector(`#product-card-price-${productId}`);
      if (priceAboveBtn) {
        // This is a single variant product - update the price above button
        updatePriceAboveButton(productId, productPrice, false);
      }
    });

    // Add to Cart Button functionality with event delegation
    document.addEventListener('click', function(e) {
      if (e.target.closest('.product-add-to-cart-btn')) {
        e.preventDefault();
        e.stopPropagation();
        
        const button = e.target.closest('.product-add-to-cart-btn');
        console.log('Add to cart button clicked:', button);
        
        if (button.disabled) return;
        
        const productId = button.dataset.productId;
        const variantId = button.dataset.variantId;
        const productTitle = button.dataset.productTitle;
        const productPrice = parseFloat(button.dataset.productPrice);
        const productVendor = button.dataset.productVendor;
        
        // Show loading state
        button.classList.add('loading');
        button.disabled = true;
        
        // Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Failed to add to cart');
          }
        })
        .then(data => {
          // Show success state
          button.classList.remove('loading');
          button.classList.add('success');
          
          // Track add to cart event
          if (typeof gtag !== 'undefined') {
            gtag('event', 'add_to_cart', {
              currency: window.Shopify?.currency?.active || 'USD',
              value: productPrice,
              items: [{
                item_id: productId,
                item_name: productTitle,
                item_brand: productVendor,
                price: productPrice,
                quantity: 1
              }]
            });
          }
          
          // Refresh cart drawer content and open it
          window.refreshCartDrawerAndOpen();
          
          // Reset button after 2 seconds
          setTimeout(() => {
            button.classList.remove('success');
            button.disabled = false;
          }, 2000);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          
          // Reset button on error
          button.classList.remove('loading');
          button.disabled = false;
          
          // Show error message (optional)
          alert('Sorry, there was an error adding this item to your cart. Please try again.');
        });
      }
    });
  }

  // Function to refresh cart drawer content and open it
  window.refreshCartDrawerAndOpen = function() {
    // First, refresh the cart drawer content
    window.refreshCartDrawerContent().then(() => {
      // Then open the cart drawer
      window.openCartDrawer();
    }).catch(error => {
      console.error('Error refreshing cart drawer:', error);
      // Still try to open the drawer even if refresh fails
      window.openCartDrawer();
    });
  }

  // Function to refresh cart drawer content
  window.refreshCartDrawerContent = function() {
    return new Promise((resolve, reject) => {
      // Get the cart drawer section ID
      const cartDrawer = document.querySelector('.cart-drawer-modal');
      if (!cartDrawer) {
        reject('Cart drawer not found');
        return;
      }

      const sectionId = cartDrawer.closest('[data-section-id]')?.getAttribute('data-section-id');
      if (!sectionId) {
        reject('Cart drawer section ID not found');
        return;
      }

      // Fetch updated cart content
      fetch(`/?section_id=${sectionId}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to fetch cart content');
          }
          return response.text();
        })
        .then(html => {
          // Create a temporary container to parse the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          
          // Find the cart drawer content in the response
          const newCartDrawer = tempDiv.querySelector('.cart-drawer-modal');
          if (!newCartDrawer) {
            throw new Error('Cart drawer content not found in response');
          }

          // Update the cart drawer content
          const currentCartDrawer = document.querySelector('.cart-drawer-modal');
          if (currentCartDrawer) {
            // Update the cart form content
            const newCartForm = newCartDrawer.querySelector('cart-form');
            const currentCartForm = currentCartDrawer.querySelector('cart-form');
            
            if (newCartForm && currentCartForm) {
              currentCartForm.innerHTML = newCartForm.innerHTML;
            }

            // Update cart count in header if it exists
            const newCartCount = newCartDrawer.querySelector('.cart-drawer__title-count');
            const currentCartCount = currentCartDrawer.querySelector('.cart-drawer__title-count');
            
            if (newCartCount && currentCartCount) {
              currentCartCount.textContent = newCartCount.textContent;
            }

            // Update cart count in header/navigation if it exists
            const headerCartCount = document.querySelector('.cart-count');
            if (headerCartCount && newCartCount) {
              headerCartCount.textContent = newCartCount.textContent.replace(/[()]/g, '');
            }

            // Trigger cart changed event for other components
            document.dispatchEvent(new CustomEvent('theme:cartchanged', {
              bubbles: true,
              cancelable: true,
              detail: { openDrawer: true }
            }));
          }

          resolve();
        })
        .catch(error => {
          console.error('Error refreshing cart drawer content:', error);
          reject(error);
        });
    });
  }

  // Function to open cart drawer
  window.openCartDrawer = function() {
    const cartDrawer = document.querySelector('.cart-drawer-modal');
    if (cartDrawer) {
      console.log('Opening cart drawer...');
      cartDrawer.setAttribute('aria-hidden', 'false');
      cartDrawer.classList.add('cc-popup--visible');
      // Prevent body scroll
      
      console.log('Cart drawer opened successfully');
    } else {
      console.log('Cart drawer element not found');
    }
  }

  // Function to close cart drawer
  window.closeCartDrawer = function() {
    const cartDrawer = document.querySelector('.cart-drawer-modal');
    if (cartDrawer) {
      cartDrawer.setAttribute('aria-hidden', 'true');
      cartDrawer.classList.remove('cc-popup--visible');
      document.body.classList.remove('cc-popup-no-scroll');
    }
  }

  // Initialize when DOM is ready
  ready(initProductCards);

  // Handle cart drawer close functionality
  document.addEventListener('click', function(e) {
    // Close cart drawer when close button is clicked
    if (e.target.closest('.cc-popup-close') || e.target.closest('.cart-drawer-modal .cc-popup-background')) {
      window.closeCartDrawer();
    }
  });

  // Re-initialize for dynamically loaded content
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList.contains('product-block') || node.querySelector('.product-block'))) {
              initProductCards();
            }
          });
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Function to update price above button for single variant products
  function updatePriceAboveButton(productId, price, comparePrice = false) {
    const priceContainer = document.querySelector(`#product-card-price-${productId}`);
    if (!priceContainer) return;

    const priceAmount = priceContainer.querySelector('.product-price-above-btn__amount');
    const priceCompare = priceContainer.querySelector('.product-price-above-btn__compare');
    const priceFrom = priceContainer.querySelector('.product-price-above-btn__from');
    
    if (priceAmount) {
      
      priceAmount.textContent = `${price} lei`;
    }

    priceCompare.style.display = 'none';
  }
})();
